<template>
	<div class="storePreview" v-if="selectedStore">
		<div class="off-canvas-close-button" data-close>&times; Close</div>
		<img
			class="logo cursor-pointer"
			:src="logoImageURL"
			@error="logoImageAlt"
			alt="Best-One"
			@click="handlePartnerClick"
		/>
		<img
			class="storePhoto"
			:src="storeImageURL"
			alt="store"
			@error="storeImageAlt"
		/>

		<div id="storePreview">
			<p v-if="selectedStore">
				<strong>{{ selectedStore.txtLocationName }}</strong>
				<br />
				{{ selectedStore.txtAddress }}
				<br />
				{{ selectedStore.txtCity }}, {{ selectedStore.full_state }}
				{{ selectedStore.txtZip }}
			</p>

			<p>
				<strong>Call Us: </strong
				><a
					style="color: #ffd91c"
					v-bind:href="'tel:' + selectedStore.phone"
					>{{ selectedStore.phone }}</a
				>
				<br />
				{{ timeText }}
			</p>
		</div>

		<button
			type="button"
			class="off-canvas-button button"
			@click="handlePartnerClick"
		>
			About Us
		</button>

		<button
			type="button"
			class="off-canvas-button button"
			@click="handleLocationClick"
		>
			Location Hours & Services
		</button>

		<hr style="border-top: 1px solid rgb(128 128 128)" />

		<button
			type="off-canvas-button button"
			data-open="scheduleModal"
			class="button"
		>
			<i class="far fa-calendar-check" data-open="scheduleModal"></i>
			Request an Appointment
		</button>

		<div class="locLink">
			<a href="#" data-open="locatorModal" class="locText"
				>Change Locations</a
			>
		</div>
	</div>
</template>

<style lang="scss" scoped>
@import "~@styles/scss/base/variables";

.off-canvas-close-button {
	text-align: left;
	padding-left: 1rem;
	padding-top: 1rem;
	// position: fixed;
	cursor: pointer;
}

// .off-canvas-button {
//     max-width: 95%;
// }

.button {
	max-width: 95%;
}

strong {
	text-transform: uppercase;
}
</style>

<script>
import { createNamespacedHelpers } from "vuex";

const { mapState, mapActions, mapGetters } =
	createNamespacedHelpers("location");

export default {
	data() {
		return {
			logoImagePath:
				"https://www.bestnet-1.com/assets/BestOneTireCom/Logos/",
			logoImageExt: "-Logo.png",

			useFallbackLogoImage: false,
			fallbackLogoImage:
				"/wp-content/themes/ferg-framework/assets/images/best-one-logo.svg",

			storeImagePreURL:
				"https://www.bestnet-1.com/assets/BestOneTireCom/StorePhotos/",
			storeImagePostURL: "-Exterior.png",
			fallbackStoreImage: "/wp-content/uploads/2020/09/signSky-1.jpg",
		};
	},

	computed: {
		...mapState(["selectedStore"]),
		...mapGetters(["timeText"]),
		storeImageURL: function () {
			if (this.selectedStore) {
				// console.log( 'Calling Main' );
				let storeImage =
					this.storeImagePreURL +
					this.selectedStore.ControlNbr +
					this.storeImagePostURL;
				// console.log( 'Ext URL Main: ', storeImage );
				return storeImage;
			}
			return this.fallbackStoreImage;
		},
		logoImageURL: function () {
			if (this.selectedStore) {
				let logoImg =
					this.logoImagePath +
					this.selectedStore.ControlNbr +
					this.logoImageExt;
				return logoImg;
			}
			return this.fallbackLogoImage;
		},
	},

	mounted: function () {
		this.requireSelectedStore();
	},

	methods: {
		...mapActions(["requireSelectedStore"]),

		handlePartnerClick: function () {
			window.location.href = `/store/${this.selectedStore.slugPartner}`;
		},

		handleLocationClick: function () {
			window.location.href = `/store/${this.selectedStore.slugPartner}/${this.selectedStore.slugCityState}/${this.selectedStore.slugLocation}`;
		},

		storeImageAlt: function (e) {
			e.target.src = this.fallbackStoreImage;
		},

		logoImageAlt: function (e) {
			let fallbackLogoImage = this.fallbackLogoImage;
			if (this.selectedStore) {
				if (
					this.useFallbackLogoImage == false &&
					this.selectedStore.txtPartnerGroup
				) {
					this.useFallbackLogoImage = true;
					fallbackLogoImage =
						this.logoImagePath +
						this.selectedStore.txtPartnerGroup +
						"-" +
						this.selectedStore.ControlNbr +
						this.logoImageExt;
				}
			}
			event.target.src = fallbackLogoImage;
		},
	},
};
</script>
